export type ThemeChannel = 'pro' | 'lite';

export function getThemeListPath(channel: ThemeChannel, adminUserId?: string): string {
  if (adminUserId) {
    return channel === 'lite'
      ? `/users/${adminUserId}/m-photo-lite?tab=themes`
      : `/users/${adminUserId}/m-photo-pro?proTab=themes`;
  }
  return channel === 'lite' ? '/m-photo-lite?tab=themes' : '/m-photo-pro?proTab=themes';
}

export function getThemeBasePath(channel: ThemeChannel, adminUserId?: string): string {
  if (adminUserId) {
    return channel === 'lite'
      ? `/users/${adminUserId}/m-photo-lite/themes`
      : `/users/${adminUserId}/m-photo-pro/themes`;
  }
  return channel === 'lite' ? '/m-photo-lite/themes' : '/m-photo-pro/themes';
}

export function getThemeDetailPath(
  channel: ThemeChannel,
  themeId: string,
  adminUserId?: string,
): string {
  return `${getThemeBasePath(channel, adminUserId)}/${themeId}`;
}

export function getThemeFramePath(
  channel: ThemeChannel,
  themeId: string,
  customFrameId: string,
  adminUserId?: string,
): string {
  return `${getThemeDetailPath(channel, themeId, adminUserId)}/custom-frames/${customFrameId}`;
}
